// extracted by mini-css-extract-plugin
export default {"amount":"style_amount__KmiuR","redColor":"style_redColor__QnQ9p","greenColor":"style_greenColor__3aOYj","summaryCell":"style_summaryCell__B55E5","content":"style_content__+6Y1z"};